import { Component, OnInit, OnDestroy, ViewChild, ViewContainerRef, ComponentFactoryResolver, EventEmitter, ViewChildren, QueryList, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '@services/api/api.service';
import { NbToastrService } from '@nebular/theme';
import { MfBladeFormsComponent } from '../mf-blade-forms/mf-blade-forms.component';
import { SelectItem, ConfirmationService, DialogService } from 'primeng/api';
import { OverlayPanel } from 'primeng/overlaypanel';
import { IdentityAuthService } from '../../../services/identity-auth/identity-auth.service';

export interface IDetailComponent {
  displayName: string;
  component?: any;
  isHidden?: boolean;
  index?: number;
  isMenuHidden?: boolean | Function;
  click?: Function;
  bladeIndexToNavigateTo?: number;
  menuHidden?: boolean;
  getDataEvenIfIsMenuHidden?: boolean;
  icon?: string;
}

export interface IButtonAction {
  text?: string;
  iconClass?: string;
  click?: Function;
  tooltip?: string;
}


@Component({
  selector: 'app-mf-blade',
  templateUrl: './mf-blade.component.html',
  styles: [':host {display: block !important;}'],
  //styleUrls: ['@framework/components/mf-blade/mf-blade.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class MfBladeComponent implements OnInit, OnDestroy {
  ngOnDestroy(): void {

  }

  @ViewChildren('components', { read: ViewContainerRef }) detailComponentTargets: QueryList<ViewContainerRef>;
  //@ViewChild('actionOverlay', { static: true }) actionOverlay: OverlayPanel;
  @ViewChildren('bladeScroll', { read: ViewContainerRef }) bladeScroll: any;
  public showActionDialog: boolean;
  public overlayIsSmallText: boolean;
  public panelHeader: string;
  public subtitle: string;
  public overlayPanelData: any = {};
  public overlayPanelIdentifier: any;
  public minimised: boolean;
  public loading: boolean;
  public menuItems: Array<SelectItem>;
  public buttonActions: Array<IButtonAction> = new Array();
  public menuActions: Array<IDetailComponent>;
  protected _hideSideMenu: boolean = false;
  protected _smallTop: boolean = false;
  public get selectedActionMenuItemIndex() {
    return null//: any;
  }
  public menuActionItems: Array<IDetailComponent>;
  public _entityId: any;
  public set entityId(val) {
    this._entityId = val;
    if (val != null)
      this.entityIdChange.emit(val);
  }
  public get entityId() {
    return this._entityId;
  }
  public _bladeSetup: any;
  public setBladeSetup() {
    var val = this._bladeSetup;
    if (val) {
      this.onSaveEvent = val.onSaveEvent;
      this.onMenuActionOverlayClick = val.onMenuActionOverlayClick;
      this.getPanelSubtitleFunc = val.getPanelSubtitleFunc;
      this.menuActions = val.menuActions;
      this.onFormLoad = val.onFormLoad;
    }
  }
  public get bladeSetup() {
    return this._bladeSetup;
  }
  public get hideSideMenu() { return this._hideSideMenu; }
  public get smallTop() { return this._smallTop; }
  public entityIdChange = new EventEmitter();
  public detailComponents: Array<IDetailComponent>;
  protected getPanelHeaderFunc: any;
  public getPanelSubtitleFunc: any;
  public onSaveEvent = function (prop) { };
  public onFormLoad = function (data, formIndex, context) { };
  public onMenuActionOverlayClick = function (context) { };
  private componentInstance: any = new Array();
  public formIndex: any;
  public displayName: any;
  public get components(): any { return this.detailComponents };
  public parent: MfBladeFormsComponent;
  public get header(): string { return this.displayName }
  public headerIdentifier: any;
  private _selectedMenuItemIndex: any = 0;
  public get selectedMenuItemIndex() {
    return this._selectedMenuItemIndex;
  }
  public set selectedMenuItemIndex(val) {
    this._selectedMenuItemIndex = val;
    if (this.componentInstance[val]) {
      if (!this.componentInstance[val].component.buttonActions)
        this.buttonActions = new Array();
      else this.buttonActions = this.componentInstance[val].component.buttonActions;

      if (this.componentInstance[val].component.resize)
        this.componentInstance[val].component.resize();

    var scrollBlade = this.bladeScroll.toArray()[val];
    if (scrollBlade) {
      setTimeout(_ => {
        if (scrollBlade.nativeElement)
          scrollBlade.nativeElement.scrollTop = 0;
      }, 1)
      }
    }
  }
  public hideClose: boolean;
  public get onBladeSave() { return this.onSaveEvent }


  constructor(public apiService?: ApiService, private route?: ActivatedRoute, private componentFactoryResolver?: ComponentFactoryResolver,
    public messageService?: NbToastrService, public confirmationService?: ConfirmationService, public dialogService?: DialogService,
    public auth?: IdentityAuthService) { }
  public setButtonActions() {
    if (!this.componentInstance[this.selectedMenuItemIndex].component.buttonActions)
      this.buttonActions = new Array();
    else this.buttonActions = this.componentInstance[this.selectedMenuItemIndex].component.buttonActions;
  }
  public minimise() {
    if (this.minimised)
      return;
    this.minimised = true;
    this.parent.minimiseForm(this.formIndex);
    this.componentInstance.forEach(o => {
      o.isHidden = true;
    })
  }

  public expandForm() {
    if (!this.minimised)
      return;
    this.minimised = false;
    this.parent.expandForm(this.formIndex);

    this.componentInstance.forEach(o => {
      o.isHidden = false;
    })
  }

  public reload() {
    this.componentInstance.forEach(o => {
      if (o.component.loadEntity)
        o.component.loadEntity();
    })
  }

  private buildComponents() {
    for (let i = 0; i < this.components.length; i++) {
      let component = this.components[i];
      if (component) {
        let target = this.detailComponentTargets.toArray()[i];
        let widgetComponent = this.componentFactoryResolver.resolveComponentFactory(component.component);
        let componentRef: any = target.createComponent(widgetComponent);
        let _component: any = (componentRef.instance);
        _component.parent = this;
        _component.listIndex = i;
        _component.menuHidden = component.menuHidden;
        this.componentInstance.push({ componentDetail: component, component: _component });
      }
    }
    if (!this.selectedMenuItemIndex)
      this.selectedMenuItemIndex = 0;


  }

  public ngOnInit() {
    this.routeChanged();

    this.parent.currentRouteParamsChange.subscribe(routeParams => {
      this.routeChanged();
    });

    this.auth.userProfileObserver.subscribe(o => {
      this.reload();
      this.components.forEach(comp => {
        if (comp.isMenuHidden instanceof Function) {
          var result = comp.isMenuHidden(comp.context, this.entityId, this.entityId == "00000000-0000-0000-0000-000000000000", comp.listIndex, comp.entityData);
          if (typeof result != 'undefined') {
            comp.menuHidden = result;
            var formInstance = this.getFormInstanceByIndex(comp.index);
            if (comp.getDataEvenIfIsMenuHidden)
              result = true;
            if (formInstance)
              this.getFormInstanceByIndex(comp.index).menuHidden = result;
          }

        }
        else {
          comp.menuHidden = comp.isMenuHidden;

          var formInstance = this.getFormInstanceByIndex(comp.index);
          if (formInstance)
            this.getFormInstanceByIndex(comp.index).menuHidden = false;
        }
      })
    })
    this.setBladeSetup();
  }

  public get getPanelSubHeader() {
    if (this.getPanelHeaderFunc) {
      var header = this.getPanelHeaderFunc(this);
      if (header && header != '')
        return ' - ' + header;
    }
    return this.headerIdentifier ? ' - ' + this.headerIdentifier : '';
  }

  public get getPanelSubTitle() {
    if (this.getPanelSubtitleFunc) {
      var subtitle = this.getPanelSubtitleFunc(this);
      if (subtitle && subtitle != '')
        return subtitle;
    }
    return this.subtitle;
  }


  public reloadDetailComponent(index: number) {
    var component = this.componentInstance[index].component;
    if (component.loadEntity)
      component.loadEntity();
  }

  routeChanged() {
    if (this.parent.currentRouteParams.hasOwnProperty("id_" + this.formIndex)) {
      if (this.entityId != this.parent.currentRouteParams["id_" + this.formIndex])
        this.entityId = this.parent.currentRouteParams["id_" + this.formIndex];
    }
    else {
      this.entityId = null;
    }
    this.buildMenus(null, this.entityId == "00000000-0000-0000-0000-000000000000")
    if (this.menuActionItems && this.menuActionItems.length <= this.selectedMenuItemIndex) {
      this.selectedMenuItemIndex = 0;
    }
  }

  public buildMenus(entityData, newItem, listIndex?, context?) {
    var self = this;
    this.components.forEach(comp => {
      if (comp.isMenuHidden instanceof Function) {
        var result = comp.isMenuHidden(context, self.entityId, newItem, listIndex, entityData);
        if (typeof result != 'undefined') {
          comp.menuHidden = result;
          var formInstance = this.getFormInstanceByIndex(comp.index);
          if (formInstance)
            this.getFormInstanceByIndex(comp.index).menuHidden = result;
        }

      }
      else {
        comp.menuHidden = comp.isMenuHidden;
        var formInstance = this.getFormInstanceByIndex(comp.index);
        if (formInstance)
          this.getFormInstanceByIndex(comp.index).menuHidden = result;
      }
    })
    this.menuItems = this.components.filter(function (comp) {
      return !comp.menuHidden
    })
      .map(o => { return { label: o.displayName, value: o.index } });

    if (this.menuActions) {
      this.menuActions.forEach(comp => {
        if (comp.isMenuHidden instanceof Function) {
          var result = comp.isMenuHidden(context, self.entityId, newItem, listIndex, entityData);
          if (typeof result != 'undefined')
            comp.menuHidden = result;
        }
        else comp.menuHidden = comp.isMenuHidden;
      })
      this.menuActionItems = this.menuActions.filter(function (comp) {
        return !comp.menuHidden
      });
    }

  }

  public ngAfterViewInit() {
    if (this.components.length > 0) {
      this.buildComponents();

      this.selectedMenuItemIndex = 0;
    }
  }
  public navigateToIndex(index, id, startNavIndex?) {
    this.parent.navigateToIndex(index, id, startNavIndex);
  }

  public closeBlade() {
    this.parent.navigateBackToIndex(this.formIndex);
  }

  public menuActionItemSelected(evt) {
    if (evt.click)
      evt.click();
  }

  public get previousEntityId() {
    this.parent.currentRouteParams
    let maxIndex = 0;
    Object.keys(this.parent.currentRouteParams).forEach(key => {
      if (key.indexOf("id_") != -1) {
        let idIndex = parseInt(key.substring(3, key.length));
        if (idIndex > maxIndex && idIndex < this.formIndex)
          maxIndex = idIndex;
      }
    });
    return this.parent.currentRouteParams["id_" + maxIndex];
  }

  public getFormInstanceByIndex(index: number) {
    var form = this.componentInstance[index];
    if (form && form.component)
      return form.component;
    else return;
  }

  public reloadFormByIndex(index: number) {
    var component = this.componentInstance[index].component;
    if (component.loadEntity)
      component.loadEntity();
  }

  public menuActionOverlayClick() {
    this.onMenuActionOverlayClick(this);
  }
}
